export const LOGIN_ROUTE = '/login';
export const ADMIN_LOGIN_ROUTE = '/admin/login';
export const FORGOTTEN_PASSWORD_ROUTE = '/forgot-password';
export const CHANGE_PASSWORD_ROUTE = '/change-password';
export const EMAIL_SENT_ROUTE = '/email-sent';
export const RESET_PASSWORD_ROUTE = '/reset-password';
export const PASSWORD_RESET_SUCCESS_ROUTE = '/password-reset-success';
export const ACTIVATE_ACCOUNT_ROUTE = '/activate-account';
/** Même flux qu’activate-account, mais après succès → /admin/login (e-mails invitation admin). */
export const ADMIN_ACTIVATE_ACCOUNT_ROUTE = '/admin/activate-account';
export const ACTIVATE_ACCOUNT_SUCCESS_ROUTE = '/activate-account-success';
/** Page succès après activation admin : toujours « Se connecter » → `/admin/login` (sans query). */
export const ADMIN_ACTIVATE_ACCOUNT_SUCCESS_ROUTE = '/admin/activate-account-success';
export const PLANIFIER_DEMO_ROUTE = '/planifier-demo';


export const DASHBOARD_ROUTE = '/';
export const MES_DEALS_ROUTE = '/mes-deals';
export const ACTIVITE_ROUTE = '/activite';
export const FILTRES_ROUTE = '/filtres';
export const ABONNEMENT_ROUTE = '/abonnement';
export const NOTIFICATIONS_ROUTE = '/notifications';
export const PARAMETRES_ROUTE = '/parametres';
export const ASSISTANCE_ROUTE = '/assistance';
export const FEEDBACK_ROUTE = '/feedback';

export const ADMIN_DASHBOARD_ROUTE = '/admin';
export const ADMIN_USERS_ROUTE = '/admin/users';
export const ADMIN_ANALYTICS_ROUTE = '/admin/analytics';
export const ADMIN_SECURITY_ROUTE = '/admin/security';
export const ADMIN_SETTINGS_ROUTE = '/admin/settings';
export const ADMIN_LOGS_ROUTE = '/admin/logs';

